import { Box, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { bkdp } from "../theme";

type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

export function PageHeader({ eyebrow, title, subtitle, actions }: PageHeaderProps) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={2}
      alignItems={{ xs: "flex-start", md: "flex-end" }}
      justifyContent="space-between"
      sx={{
        pb: 3,
        borderBottom: `1.5px solid ${bkdp.greyLight}`
      }}
    >
      <Box sx={{ maxWidth: 640 }}>
        {eyebrow && (
          <Typography
            variant="overline"
            sx={{ color: bkdp.signalBlue, display: "block", mb: 1 }}
          >
            {eyebrow}
          </Typography>
        )}
        <Typography variant="h2" sx={{ color: bkdp.deepNavy }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" sx={{ color: bkdp.textBody, mt: 1.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions ? <Box>{actions}</Box> : null}
    </Stack>
  );
}
